import { render, staticRenderFns } from "./c_menu_list.vue?vue&type=template&id=b9629dd4&scoped=true"
import script from "./c_menu_list.vue?vue&type=script&lang=js"
export * from "./c_menu_list.vue?vue&type=script&lang=js"
import style0 from "./c_menu_list.vue?vue&type=style&index=0&id=b9629dd4&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9629dd4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/adam/Documents/Private_Repository/sjtx/backendAdmin/sjtx_admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b9629dd4')) {
      api.createRecord('b9629dd4', component.options)
    } else {
      api.reload('b9629dd4', component.options)
    }
    module.hot.accept("./c_menu_list.vue?vue&type=template&id=b9629dd4&scoped=true", function () {
      api.rerender('b9629dd4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pagediy/components/mobileConfigRight/c_menu_list.vue"
export default component.exports